import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-gray-100 py-12"
}
const _hoisted_2 = { class: "container mx-auto px-4 max-w-7xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-gray-800 mb-4" }, "EXPOSITORES", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-gray-800 mb-4" }, "Por favor complete el formulario en su totalidad", -1)
const _hoisted_5 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_6 = { class: "w-full px-2 md:w-1/5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "DNI", -1)
const _hoisted_8 = { class: "text-sm text-red-500 p-error" }
const _hoisted_9 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)
const _hoisted_11 = { class: "text-sm text-red-500 p-error" }
const _hoisted_12 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)
const _hoisted_14 = { class: "text-sm text-red-500 p-error" }
const _hoisted_15 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_16 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Empresa", -1)
const _hoisted_18 = { class: "text-sm text-red-500 p-error" }
const _hoisted_19 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Tarea que desarrolla", -1)
const _hoisted_21 = { class: "text-sm text-red-500 p-error" }
const _hoisted_22 = { class: "w-full px-2 md:w-1/5" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "CUIT", -1)
const _hoisted_24 = { class: "text-sm text-red-500 p-error" }
const _hoisted_25 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_26 = { class: "w-full px-2 md:w-1/3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Fecha de nacimiento", -1)
const _hoisted_28 = { class: "text-sm text-red-500 p-error" }
const _hoisted_29 = { class: "w-full px-2 md:w-2/3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Mail", -1)
const _hoisted_31 = { class: "text-sm text-red-500 p-error" }
const _hoisted_32 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_35 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: _ctx.onSubmit,
      "validation-schema": _ctx.schema,
      class: "space-y-4 text-gray-700"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_Field, {
                name: "dni",
                modelValue: _ctx.formData.dni,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dni) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "DNI / Pasaporte"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_ErrorMessage, { name: "dni" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_Field, {
                name: "nombre",
                modelValue: _ctx.formData.nombre,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.nombre) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Nombre"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_ErrorMessage, { name: "nombre" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_Field, {
                name: "apellido",
                modelValue: _ctx.formData.apellido,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.apellido) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Apellido"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_ErrorMessage, { name: "apellido" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_Field, {
                name: "empresa",
                modelValue: _ctx.formData.empresa,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.empresa) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Empresa"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_18, [
                    _createVNode(_component_ErrorMessage, { name: "empresa" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_Field, {
                name: "tarea",
                modelValue: _ctx.formData.tarea,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.tarea) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value }) => [
                  _createVNode(_component_Dropdown, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione la tarea que desarrolla",
                    class: "w-full md:w-14rem p-inputtext-sm",
                    options: _ctx.tareas,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options"]),
                  _createElementVNode("span", _hoisted_21, [
                    _createVNode(_component_ErrorMessage, { name: "tarea" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_Field, {
                name: "cuit",
                modelValue: _ctx.formData.cuit,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.cuit) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    class: "w-full p-3",
                    placeholder: "CUIT / Matrícula"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_24, [
                    _createVNode(_component_ErrorMessage, { name: "cuit" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_Field, {
                name: "fechaNacimiento",
                modelValue: _ctx.formData.fechaNacimiento,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.fechaNacimiento) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Calendar, _mergeProps(field, {
                    "model-value": _ctx.formData.fechaNacimiento,
                    class: "w-full p-inputtext",
                    placeholder: "Fecha de nacimiento",
                    dateFormat: "dd/mm/yy"
                  }), null, 16, ["model-value"]),
                  _createElementVNode("span", _hoisted_28, [
                    _createVNode(_component_ErrorMessage, { name: "fechaNacimiento" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_Field, {
                name: "mail",
                modelValue: _ctx.formData.mail,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.mail) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "mail",
                    class: "w-full p-inputtext-sm p-3",
                    placeholder: "Mail"
                  }), null, 16),
                  _createElementVNode("span", _hoisted_31, [
                    _createVNode(_component_ErrorMessage, { name: "mail" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("button", {
              type: "submit",
              label: "REGISTRARME",
              class: "mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
              disabled: _ctx.isSubmitting
            }, [
              _withDirectives(_createElementVNode("i", _hoisted_34, null, 512), [
                [_vShow, _ctx.isSubmitting]
              ]),
              _withDirectives(_createElementVNode("i", _hoisted_35, null, 512), [
                [_vShow, !_ctx.isSubmitting]
              ]),
              _createTextVNode("REGISTRARME ")
            ], 8, _hoisted_33)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}